var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('router-link',{staticClass:"btn blue-grey lighten-2 back-btn left",attrs:{"to":"/debitare"}},[_vm._v("Inapoi")]),_c('div',{staticClass:"btns right"}),_c('h4',[_vm._v("Rapoarte debitare")]),_c('div',{staticClass:"row"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }